/**
 * Labels + Badge-Styles fuer das kanonische ANWESENHEITSSTATUS-Enum
 * (backend/app/models/enums.py — Ninox hatte 3 invertierte Varianten).
 */

import type { Anwesenheitsstatus } from "@/types"

export const ATTENDANCE_STATUS: Record<
  Anwesenheitsstatus,
  { label: string; badge: string }
> = {
  ANWESEND: {
    label: "Anwesend",
    badge: "border-green-300 bg-green-100 text-green-800",
  },
  KRANK: {
    label: "Krank",
    badge: "border-yellow-300 bg-yellow-100 text-yellow-800",
  },
  URLAUB: {
    label: "Urlaub",
    badge: "border-blue-300 bg-blue-100 text-blue-800",
  },
  UNENTSCHULDIGT: {
    label: "Unentschuldigt",
    badge: "border-red-300 bg-red-100 text-red-800",
  },
  RUECKRUF: {
    label: "Rückruf",
    badge: "border-orange-300 bg-orange-100 text-orange-800",
  },
}

export const ATTENDANCE_STATUS_VALUES = Object.keys(
  ATTENDANCE_STATUS
) as Anwesenheitsstatus[]
